import FFL from "../../../../static/companies/FFL.png";
import FI from "../../../../static/companies/FounderInstitute.png";
import FS from "../../../../static/companies/FounderSuite.png";
import KT from "../../../../static/companies/KiwiTech.png";
import KCX from "../../../../static/companies/KCX.png";
import PS from "../../../../static/companies/PS.png";
import ESMS from "../../../../static/companies/ESMS.jpg";

export const PARTNERS = [
  {
    id: "YQ-FCJWnRVCqgDdpP-L0OQ",
    name: "TriNet Group",
    logo:
      "https://content.radivision.com/images/ki/fb/KIfbuxKXRcGbdbfZWletpg.png?wip=580&hip=580&r=xV0seP3AQJqb6Q078mpLsQ",
    url: "https://www.radivision.com/company/Trinet/YQ-FCJWnRVCqgDdpP-L0OQ",
  },
  {
    id: "sjTe0PuGR4O4iF6RPK4BMQ",
    name: "Title 3 Funds",
    logo:
      "https://content.radivision.com/images/xf/jl/xFjlCOaFSSOSb6Gm5IERgA.png?wip=580&hip=580&r=dPdlxM1VTaa8uC6U7zWALQ",
    url: "https://www.radivision.com/company/Title%203%20Funds/sjTe0PuGR4O4iF6RPK4BMQ",
  },
  {
    id: "p9zyEoCgTh2qcdP9dyo9qw",
    name: "Founder Institute",
    logo: `${FI}`,
    url: "/company/Founder%20Institute/p9zyEoCgTh2qcdP9dyo9qw",
  },
  {
    id: "gvQIF7AyS1GRtqAwf3DFaw",
    name: "ESMS",
    logo: `${ESMS}`,
    url: "/company/gvQIF7AyS1GRtqAwf3DFaw",
  },
  {
    id: "6JQwuFiXQ9uEoyi7oW3huA",
    name: "SAP.io",
    logo:
      "https://content.radivision.com/images/jp/jy/JPJY7C8YQRde6ayMJfKDoQ.png?wip=580&hip=580&r=GjMK5aTBSzyKJe-oBxnZUg",
    url: "/company/SAP_io/6JQwuFiXQ9uEoyi7oW3huA",
  },
  {
    //  id: "hd3AhFMFQgyeGwffAy2zCQ",
    name: "Peachscore Accelerator",
    logo: `${PS}`,
    //  url: "/company/WeFunder/hd3AhFMFQgyeGwffAy2zCQ",
  },
  {
    id: "ZuNZWuMVSqyX12oY-L2ntg",
    name: "KoreConX",
    logo: `${KCX}`,
    url: "/company/KoreConX/ZuNZWuMVSqyX12oY-L2ntg",
  },
  {
    id: "g5EzuZImSqSrFkD3HjEeiw",
    name: "Expert Dojo",
    logo:
      "https://content.radivision.com/images/mh/nx/MHNxXoWMRlefSrmA9yAfGw.png?wip=580&hip=580&r=fgn0LxHqQnWYEgrHlMRfsA",
    url: "/company/Expert%20Dojo/g5EzuZImSqSrFkD3HjEeiw",
  },

  // {
  //   id: "hd3AhFMFQgyeGwffAy2zCQ",
  //   name: "WeFunder",
  //   logo:
  //     "https://content.radivision.com/images/yt/po/ytPoqt5wQnWGf8H3LvkIag.png?wip=580&hip=580&r=bkpwMGrcRoCa5zUpRIhsQA",
  //   url: "/company/WeFunder/hd3AhFMFQgyeGwffAy2zCQ",
  // },
  // {
  //   id: "l2p5Uzd3QlqrcvS1IhqpGA",
  //   name: "Female Founders Labs",
  //   logo: `${FFL}`,
  //   url: "https://www.radivision.com/company/The%20Female%20Founders%20Lab/l2p5Uzd3QlqrcvS1IhqpGA",
  // },
  // {
  //   id: "ZYIQ8Je4TTiKYSBR8gEeYg",
  //   name: "High Touch Investor Relations",
  //   logo:
  //     "https://content.radivision.com/images/sy/pd/sYPdmER3RIG74kT6EOOANQ.png?wip=580&hip=580&r=bzgjzfTWQ7SOiq2_Q_2XLQ",
  //   url: "/company/High%20Touch%20Investor%20Relations/ZYIQ8Je4TTiKYSBR8gEeYg",
  // },

  // {
  //   id: "vBCDpPz2RqO5eE_YOxIN4Q",
  //   name: "FounderSuite",
  //   logo: `${FS}`,
  //   url: "https://www.radivision.com/company/FounderSuite/vBCDpPz2RqO5eE_YOxIN4Q",
  // },
  // {
  //   id: "uHar1qqyTsGEB3uqzVAHgA",
  //   name: "KiwiTech",
  //   logo: `${KT}`,
  //   url: "/company/KiwiTech/uHar1qqyTsGEB3uqzVAHgA",
  // },
];
